import { SavedReportsPage } from '@/pages/reports'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/dashboard/reports/')({
	component: SavedReportsPage,
})
